import { initGraphQLTada } from 'gql.tada';
export const graphql = initGraphQLTada();
export { maskFragments, readFragment } from 'gql.tada';
//# sourceMappingURL=server.js.map